// Wait for the DOM to load before showing the popup
document.addEventListener('DOMContentLoaded', function() {
  // Get the popup overlay and content elements
  var popupOverlay = document.querySelector('.popup-overlay');
  var popupContent = document.querySelector('.popup-content');

  // Get the popup close button
  var popupClose = document.querySelector('.popup-close');

  // Check if the popup should be displayed
  if (!getCookie('popupShown')) {
    // Show the popup if it hasn't been displayed yet
    popupOverlay.style.display = 'block';
    popupContent.style.display = 'block';
    
    // Set a cookie to track that the popup has been displayed
    setCookie('popupShown', 'true', 30);
  }

  // Close the popup when the close button is clicked
  popupClose.addEventListener('click', function() {
    popupOverlay.style.display = 'none';
    popupContent.style.display = 'none';
  });
});

// Set a cookie with a name, value, and expiration time (in days)
function setCookie(name, value, days) {
  var expires = '';
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = '; expires=' + date.toUTCString();
  }
  document.cookie = name + '=' + (value || '')  + expires + '; path=/';
}

// Get the value of a cookie by name
function getCookie(name) {
  var nameEQ = name + '=';
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}